import { createBootReliabilityAriaEvent } from 'owa-shared-start/lib/createBootReliabilityAriaEvent';
import { lazyPostSignal } from 'mini-start-analytics';
import type StartConfig from '../types/StartConfig';

export function onBootComplete(config: StartConfig, start?: number) {
    const timings = window.performance?.now && {
        start,
        plt: config.wasUserPrompted ? -1 : Math.floor(window.performance.now()),
    };

    lazyPostSignal.importAndExecute(createBootReliabilityAriaEvent('ok', undefined, timings));
}
